export default "__VITE_ASSET__5ycYNeLr__"